import React from "react";
import HmisReportList from "../../Hmis/Report/HmisReportList";

export default function HmisReport(): React.ReactNode {
  return <HmisReportList />;
}
